/** ファイルアップロード上限サイズ(MB) */
export const UPLOAD_SIZE_LIMIT = 10;
